import { Confirmation, ConfirmationTitle } from './Confirmation/Confirmation'
import { Initializing, InitializingTitle } from './Initializing/Initializing'
import { PaymentForm, PaymentFormTitle } from './PaymentForm/PaymentForm'

export const Payment = {
    Initializing: {
        Title: () => <InitializingTitle />,
        View: () => <Initializing />,
    },
    PaymentForm: {
        Title: () => <PaymentFormTitle />,
        View: () => <PaymentForm />,
    },
    Confirmation: {
        Title: () => <ConfirmationTitle />,
        View: () => <Confirmation />,
    },
}
